module.exports = __webpack_public_path__ + "img/iconBussinessTruckQueue.fc01da9a.svg";